<template>
  <div>
    <el-table
      :data="videos.data"
      :highlight-current-row="false"
      :row-class-name="tableRowClassName"
      class="video-tracks-scan"
      v-loading="loading"
    >
      <el-table-column label="Video/Channel" width="300">
        <template slot-scope="props">
          <i class="shorts-icon" v-if="props.row.short === 1"></i>
          <a
            :href="`https://youtube.com/watch?v=${props.row.video_id}`"
            target="_blank"
          >
            {{ props.row.video_title }}
          </a>
          <br />
          <a
            :href="`https://youtube.com/channel/${props.row.channel_id}`"
            target="_blank"
          >
            {{ props.row.channel_name }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="Views">
        <template slot-scope="props">
          {{ props.row.views | formatNumber }}
        </template>
      </el-table-column>
      <el-table-column label="Subscribers">
        <template slot-scope="props">
          {{ props.row.subscribers | formatNumber }}
        </template>
      </el-table-column>
      <el-table-column label="Publish date">
        <template slot-scope="props">
          {{ props.row.video_published | datetimesec }}
        </template>
      </el-table-column>
      <el-table-column label="Artist/Track" width="200">
        <template slot-scope="props">
          {{ props.row.artist_name }}
          <br />
          {{ props.row.track_name }}
        </template>
      </el-table-column>
      <el-table-column label="Uninterrupted" width="100">
        <template slot-scope="props">
          <el-input v-model="props.row.uninterruptedSeconds"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="center" width="200">
        <template slot-scope="props">
          <el-tooltip content="Approve" v-if="props.row.video_approved !== 1">
            <el-button
              type="success"
              circle
              size="small"
              icon="el-icon-check"
              @click="approve(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Reject" v-if="props.row.video_approved !== 0">
            <el-button
              type="danger"
              circle
              size="small"
              icon="el-icon-close"
              @click="reject(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Save" v-if="showSaveButton(props.row)">
            <el-button
              circle
              size="small"
              icon="el-icon-finished"
              @click="update(props.row)"
            ></el-button>
          </el-tooltip>
          <el-popover placement="left" width="400" trigger="click">
            <el-table
              :data="trackDuration"
              class="w100"
              stripe
              v-loading="trackDurationLoader"
            >
              <el-table-column prop="start_time" label="Start Time"
                ><template slot-scope="props">{{
                  props.row.start_time
                }}</template></el-table-column
              >
              <el-table-column prop="end_time" label="End Time"
                ><template slot-scope="props">{{
                  props.row.end_time
                }}</template></el-table-column
              >
              <el-table-column prop="duration" label="Duration"
                ><template slot-scope="props">{{
                  props.row.duration
                }}</template></el-table-column
              >
            </el-table>
            <el-button
              slot="reference"
              circle
              size="small"
              icon="el-icon-set-up"
              @click="
                getTrackDuration({
                  videoId: props.row.video_id,
                  trackId: props.row.track_id
                })
              "
            ></el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="videos.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="videos.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  props: ['artist_credited'],

  computed: {
    ...mapState('vcVideoTracksScanRegular', [
      'wheres',
      'credits',
      'trackDuration',
      'trackDurationLoader'
    ]),
    ...mapState('vcVideoTrackScanFreeVideos', [
      'videos',
      'loading',
      'page',
      'page_size',
      'order_column',
      'order_type'
    ])
  },

  filters: {
    formatNumber(value) {
      return String(value).replace(/(.)(?=(\d{3})+$)/g, '$1,')
    }
  },

  methods: {
    ...mapMutations('vcVideoTrackScanFreeVideos', [
      'setPageVideo',
      'setPageSize'
    ]),
    ...mapActions('vcVideoTracksScanRegular', ['getTrackDuration']),
    ...mapActions('vcVideoTrackScanFreeVideos', [
      'readFreeVideos',
      'update',
      'approve',
      'reject'
    ]),

    showSaveButton(row) {
      return (
        (row.video_approved !== null && row.approved !== null) ||
        (row.video_approved === null && row.approved === null)
      )
    },

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readFreeVideos()
    },
    currentChange(page) {
      this.setPageVideo(page)
      this.readFreeVideos()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readFreeVideos()
    },
    tableRowClassName({ row }) {
      if (row.video_approved === 1) {
        return 'green-row'
      } else if (row.video_approved === 0) {
        return 'red-row'
      }
      if (row.approved === 1) return 'yellow-row'
      if (row.approved === 0) return 'red-row'

      return ''
    }
  },

  created() {
    this.readFreeVideos()
  }
}
</script>

<style>
.el-table tr.green-row {
  background-color: #d6f3d6;
}
.el-table tr.red-row {
  background-color: #ffeded;
}
.el-table tr.grey-row {
  background-color: #bdbdbd;
}
.el-table tr.yellow-row {
  background-color: #fcf1dc;
}
.video-tracks-scan.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: transparent;
}
</style>
